import { render, staticRenderFns } from "./SimpleKeyboard.vue?vue&type=template&id=7318ad1a&scoped=true&"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318ad1a",
  null
  
)

export default component.exports